<template>
  <div class="wrap-block">
    <div class="panel">
      <payment-panel-select-period id="shd" :active-date="activeDate" :default-status-button="2" class="date-selected" :normal-date="true" :hide-date-picker="hideDatePicker" :return-type="true"  @changeDate="changeDate"></payment-panel-select-period>
      <div class="select-chart">
        <button :class="{'button-active': !chartStatus}" v-on:click="changeChart">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.8925 7.35105L14.8309 7.00474C14.722 6.99278 14.6119 7.0035 14.5069 7.03628C14.4019 7.06906 14.3042 7.12324 14.2194 7.1957C14.1347 7.26816 14.0645 7.35745 14.0129 7.45842C13.9614 7.55938 13.9295 7.67002 13.9192 7.78393C13.9037 8.01669 13.976 8.24654 14.1205 8.42445C14.2651 8.60236 14.4704 8.71425 14.6928 8.73628L16.9861 8.93829L12.814 13.296L10.6588 11.045C10.584 10.9629 10.494 10.8976 10.3942 10.8529C10.2945 10.8083 10.1871 10.7853 10.0786 10.7853C9.97008 10.7853 9.86269 10.8083 9.76295 10.8529C9.66321 10.8976 9.5732 10.9629 9.49836 11.045L4.33156 16.4416C4.23655 16.516 4.15797 16.6109 4.10112 16.7198C4.04428 16.8287 4.0105 16.9491 4.00209 17.0729C3.99367 17.1966 4.0108 17.3208 4.05233 17.437C4.09385 17.5532 4.1588 17.6587 4.24278 17.7464C4.32675 17.8341 4.42779 17.902 4.53905 17.9453C4.65031 17.9887 4.7692 18.0066 4.88766 17.9978C5.00612 17.989 5.12139 17.9538 5.22565 17.8944C5.32992 17.835 5.42076 17.7529 5.49202 17.6537L10.0786 12.892L12.2337 15.1141C12.3064 15.1991 12.396 15.2664 12.4962 15.3112C12.5965 15.3561 12.7049 15.3775 12.814 15.3738C12.9225 15.3738 13.0299 15.3508 13.1296 15.3062C13.2293 15.2615 13.3193 15.1962 13.3942 15.1141L18.1465 10.1504L18.3399 12.5457C18.354 12.7651 18.4475 12.9708 18.6014 13.1209C18.7554 13.2709 18.9583 13.3542 19.1688 13.3537H19.2517C19.4691 13.3248 19.6676 13.2099 19.8064 13.0328C19.9452 12.8556 20.0136 12.6296 19.9977 12.4014L19.6662 8.13024C19.6469 7.92554 19.5584 7.73471 19.4166 7.59194C19.2749 7.44916 19.0891 7.36377 18.8925 7.35105Z" fill="#9AA3B0"/>
          </svg>
        </button>
        <button :class="{'button-active': chartStatus}" v-on:click="changeChart">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="14" width="2" height="5" rx="1" fill="#9AA3B0"/>
            <rect x="9" y="9" width="2" height="10" rx="1" fill="#9AA3B0"/>
            <rect x="13" y="12" width="2" height="7" rx="1" fill="#9AA3B0"/>
            <rect x="17" y="5" width="2" height="14" rx="1" fill="#9AA3B0"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="block"></div>
    <div class="chart-block-c" :id="idChartDir"></div>
    <div class="no-data" v-if="dataChart.length === 0 && !showLoaderRequest">
      <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M47.8618 12.3906C47.8618 11.8383 48.3095 11.3906 48.8618 11.3906H61.4018C61.9541 11.3906 62.4018 11.8383 62.4018 12.3906V18.8006H74.5118C75.0641 18.8006 75.5118 19.2483 75.5118 19.8006V25.5006C75.5118 26.0529 75.0641 26.5006 74.5118 26.5006C73.9595 26.5006 73.5118 26.0529 73.5118 25.5006V20.8006H62.4018V40.8906C62.4018 41.4429 61.9541 41.8906 61.4018 41.8906C60.8495 41.8906 60.4018 41.4429 60.4018 40.8906V13.3906H49.8618V42.0306C49.8618 42.5829 49.4141 43.0306 48.8618 43.0306C48.3095 43.0306 47.8618 42.5829 47.8618 42.0306V33.9106H37.3218V51.1506C37.3218 51.7029 36.8741 52.1506 36.3218 52.1506C35.7695 52.1506 35.3218 51.7029 35.3218 51.1506V29.3506H24.2118V47.1606C24.2118 47.7129 23.7641 48.1606 23.2118 48.1606C22.6595 48.1606 22.2118 47.7129 22.2118 47.1606V40.1806H11.6718V55.7106C11.6718 56.2629 11.2241 56.7106 10.6718 56.7106C10.1195 56.7106 9.67177 56.2629 9.67177 55.7106V39.1806C9.67177 38.6283 10.1195 38.1806 10.6718 38.1806H22.2118V28.3506C22.2118 27.7983 22.6595 27.3506 23.2118 27.3506H36.3218C36.8741 27.3506 37.3218 27.7983 37.3218 28.3506V31.9106H47.8618V12.3906ZM74.3643 34.7716C74.6364 34.731 74.9132 34.8043 75.1296 34.9743L83.1096 41.2443C83.5439 41.5855 83.6193 42.2142 83.2781 42.6484C82.9369 43.0827 82.3082 43.1582 81.874 42.8169L74.7267 37.2012L62.2222 55.1424C61.9545 55.5264 61.4564 55.6734 61.0231 55.4962L49.0986 50.618L37.0289 62.6877C36.7291 62.9875 36.2728 63.0657 35.8903 62.8828L23.3534 56.8868L11.305 66.7446C10.9454 67.0388 10.4304 67.0466 10.0621 66.7632L2.65206 61.0632C2.2143 60.7265 2.13241 60.0987 2.46914 59.6609C2.80588 59.2232 3.43372 59.1413 3.87148 59.478L10.6526 64.6942L22.5785 54.9367C22.8786 54.6912 23.2935 54.6412 23.6432 54.8085L36.115 60.7732L48.1547 48.7335C48.4395 48.4486 48.8675 48.3625 49.2404 48.5151L61.0393 53.3419L73.6914 35.1888C73.8487 34.9631 74.0921 34.8122 74.3643 34.7716ZM48.8618 59.2706C49.4141 59.2706 49.8618 59.7183 49.8618 60.2706V82.5006C49.8618 83.0529 49.4141 83.5006 48.8618 83.5006H3.26177C2.70948 83.5006 2.26177 83.0529 2.26177 82.5006C2.26177 81.9483 2.70948 81.5006 3.26177 81.5006H9.67177V74.5206C9.67177 73.9683 10.1195 73.5206 10.6718 73.5206C11.2241 73.5206 11.6718 73.9683 11.6718 74.5206V81.5006H22.2118V65.9706C22.2118 65.4183 22.6595 64.9706 23.2118 64.9706C23.7641 64.9706 24.2118 65.4183 24.2118 65.9706V81.5006H35.3218V71.6706C35.3218 71.1183 35.7695 70.6706 36.3218 70.6706C36.8741 70.6706 37.3218 71.1183 37.3218 71.6706V81.5006H47.8618V60.2706C47.8618 59.7183 48.3095 59.2706 48.8618 59.2706Z" fill="#DEE3EA"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M77.6143 59C70.1134 59 64 65.2043 64 72.8985C64 80.5926 70.1134 86.7969 77.6143 86.7969C81.9806 86.7969 85.8719 84.699 88.3673 81.4237C90.1599 79.071 91.2286 76.1144 91.2286 72.8985C91.2286 65.2043 85.1152 59 77.6143 59ZM62 72.8985C62 64.1362 68.9727 57 77.6143 57C86.2559 57 93.2286 64.1362 93.2286 72.8985C93.2286 76.2506 92.2086 79.364 90.4659 81.9303L96.7139 88.2997C97.1006 88.694 97.0945 89.3271 96.7003 89.7139C96.306 90.1006 95.6729 90.0945 95.2861 89.7003L89.2285 83.5249C86.3738 86.7573 82.23 88.7969 77.6143 88.7969C68.9727 88.7969 62 81.6607 62 72.8985Z" fill="#DEE3EA"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M82.6953 67.8603C83.0858 68.2509 83.0858 68.884 82.6953 69.2746L79.0812 72.8887L82.6953 76.5028C83.0858 76.8933 83.0858 77.5265 82.6953 77.917C82.3048 78.3075 81.6716 78.3075 81.2811 77.917L77.667 74.3029L74.0529 77.917C73.6624 78.3075 73.0292 78.3075 72.6387 77.917C72.2482 77.5265 72.2482 76.8933 72.6387 76.5028L76.2528 72.8887L72.6387 69.2746C72.2482 68.884 72.2482 68.2509 72.6387 67.8603C73.0292 67.4698 73.6624 67.4698 74.0529 67.8603L77.667 71.4744L81.2811 67.8603C81.6716 67.4698 82.3048 67.4698 82.6953 67.8603Z" fill="#DEE3EA"/>
      </svg>
      <p class="fz14 fw500 text-dark1">There is no data</p>
    </div>
    <transition name="fade">
      <app-loader v-if="showLoaderRequest" class="loader-chart"></app-loader>
    </transition>
<!--    <pre>-->
<!--      {{dataChart}}-->
<!--    </pre>-->
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import PaymentPanelSelectPeriod from "@/components/payment/payment-panel-select-period";
import {mapActions, mapGetters} from "vuex";
import moment from 'moment';
import AppLoader from "@/components/loader";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
export default {
  props: ["hideDate", 'idChartDirChange'],
  name: "payment-list-charts",
  components: {AppLoader, PaymentPanelSelectPeriod},
  computed: {
    ...mapGetters(["getPaymentCashFlow"]),
  },
  data() {
    return {
      hideDatePicker: true,
      dataChart: [],
      chart: {},
      chartFirst: null,
      chartSecond: null,
      type: "",
      chartStatus: false,
      idChartDir: 'chartdiv',
      defaultStatusButton: "no",
      activeDate: [],
      showLoaderRequest: false,
    }
  },
  watch: {
    idChartDirChange: function () {
      if(this.idChartDirChange !== null && this.idChartDirChange !== undefined) {
        this.idChartDir = this.idChartDirChange;
        this.$emit("render")
      }
    },
    getPaymentCashFlow: function () {
      this.clearChart();
      this.clearDataChart();
      this.dataChart = JSON.parse(JSON.stringify(this.getPaymentCashFlow));
      this.dataChart = this.dataChart.map(a=> {
        a.date = new Date(a.date);
        return a;
      })
      this.setNewDateForChart();
      if(this.chartStatus) {
        this.addSeries();
      } else {
        this.addSeries2();
      }
    },
  },
  methods: {
    ...mapActions(["axiosGetPaymentCashFlow"]),
    changeChart() {
      this.chartStatus = !this.chartStatus;
      this.clearChart();
      this.clearDataChart();
      this.dataChart = JSON.parse(JSON.stringify(this.getPaymentCashFlow));
      this.dataChart = this.dataChart.map(a=> {
        a.date = new Date(a.date);
        return a;
      })
      this.setNewDateForChart();
      if(this.chartStatus) {
        this.addSeries();
      } else {
        this.addSeries2();
      }
    },
    changeDate(date) {
      this.type = date.type;
      // if(date.date[0] !== null) {
      //   date.date[0] = moment(date.date[0]).format("YYYY-MM-DDT00:00:00Z")
      // }
      // if(date.date[1] !== null) {
      //   date.date[1] = moment(date.date[1]).format("YYYY-MM-DDT23:59:00Z")
      // }
      let date1 =  date.date[0];
      if(date1 !== null) {
        date1 = moment(date1).format("YYYY-MM-DD 00:00:00")
        // date1 = moment(date1).format("YYYY-MM-DD HH:mm:ss")
      }
      let date2 =  date.date[1];
      if(date2 !== null) {
        date2 = moment(date2).format("YYYY-MM-DD 23:59:00")
      }
      this.showLoaderRequest = true;
      this.axiosGetPaymentCashFlow({date_before: date1, date_after: date2, group_by: date.type}).then(()=> {
        this.showLoaderRequest = false;
      })
      // this.axiosGetCashFlowDiagram({date_before: date1, date_after: date2, group_by: date.type})
      localStorage.removeItem(this.$route.path+"2")
      // console.log("CONS DATE")
      localStorage.setItem(this.$route.path+"2", JSON.stringify(date.date));
      // console.log(date.date)
      // console.log(JSON.parse(this.$cookies.get(this.$route.path+"2")))
    },
    setNewDateForChart() {
      this.createNewChart();
      // console.log(this.chart)
      // console.log("setNewDateForChart")
      // this.chart = am4core.create(this.idChartDir, am4charts.XYChart);
      // this.chart.colors.step = 2;
      // am4core.options.autoSetClassName = true;
      //
      // let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      // xAxis.dataFields.category = 'date'
      // xAxis.renderer.cellStartLocation = 0.4
      // xAxis.renderer.cellEndLocation = 0.6
      // xAxis.renderer.grid.template.location = 0;
      //
      //
      //
      // xAxis.renderer.minGridDistance = 100;
      // xAxis.renderer.grid.template.location = 0.5;
      // console.log(this.chart.yAxes)
      // this.chart.yAxes._values = []
      // let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      // yAxis.min = 0;
      // console.log()
      this.chart.data = this.dataChart;
      // this.chart.data = JSON.parse(JSON.stringify(this.dataChart));
      if(this.type !== 'year' && this.type !== 'month'){
        for(let i=0; i<this.chart.data.length; i++) {
          this.chart.data[i].dateNatural = new Date(this.chart.data[i].date)
          this.chart.data[i].date = ""+moment(new Date(this.chart.data[i].date)).format("DD");
        }
      }
      if(this.type === 'month') {
        for(let i=0; i<this.chart.data.length; i++) {
          this.chart.data[i].dateNatural = new Date(this.chart.data[i].date)
          this.chart.data[i].date = ""+moment(new Date(this.chart.data[i].date)).format("MMM");
        }
      }
      if(this.type === "year") {
        for(let i=0; i<this.chart.data.length; i++) {
          this.chart.data[i].dateNatural = new Date(this.chart.data[i].date)
          // console.log('234')

          this.chart.data[i].date = ""+moment(new Date(this.chart.data[i].date)).format("YYYY");
        }
      }


      // for(let i=0; i<this.chart.data.length; i++) {
      //   this.chart.data[i].date = ""+moment(this.chart.data[i].date).format("DD.MM.YYYY");
      // }
    },
    clearDataChart() {
      this.chart.data.splice(0,this.chart.data.length);
      // this.chart = null;
    },
    clearChart() {
      if(this.chartFirst !== null && this.chartSecond !== null) {
        this.chartFirst = null;
        this.chartSecond = null;
        this.chart.series.removeIndex(0);
        this.chart.series.removeIndex(0);
      }
    },
    addSeries() {
      this.chartFirst = this.createSeries("income", "name", '#0FA54E');
      this.chartSecond = this.createSeries("expense", "name2", "#E85353");
    },
    addSeries2() {
      this.chartFirst = this.chart.series.push(new am4charts.LineSeries());
      this.chartFirst.dataFields.valueY = "expense";
      this.chartFirst.dataFields.categoryX = "date";
      this.chartFirst.strokeWidth = 2;
      // series.tooltipText = "[bold]{date.formatDate()}:[/] {income}\n[bold]{previousDate.formatDate()}:[/] {expense}";
      this.chartFirst.tooltip.pointerOrientation = "vertical";
      this.chartFirst.stroke = am4core.color("#E85353");
      var bullet = this.chartFirst.bullets.push(new am4charts.CircleBullet());
      // bullet.circle.stroke = am4core.color("#fff");
      bullet.circle.strokeWidth = 2;
      bullet.fillOpacity = 0;
      bullet.strokeOpacity = 0;
      var bulletState = bullet.states.create("hover");
      bulletState.properties.fillOpacity = 1;
      bulletState.properties.strokeOpacity = 1;


// Create series
      this.chartSecond = this.chart.series.push(new am4charts.LineSeries());
      this.chartSecond.dataFields.valueY = "income";
      this.chartSecond.dataFields.categoryX = "date";
      this.chartSecond.strokeWidth = 2;
      this.chartSecond.stroke = am4core.color('#0FA54E');
      var bullet1 = this.chartSecond.bullets.push(new am4charts.CircleBullet());
      // bullet.circle.stroke = am4core.color("#fff");
      bullet1.circle.strokeWidth = 2;
      bullet1.fillOpacity = 0;
      bullet1.strokeOpacity = 0;
      var bulletState1 = bullet1.states.create("hover");
      bulletState1.properties.fillOpacity = 1;
      bulletState1.properties.strokeOpacity = 1;
      // this.chartSecond.stroke = series.stroke;
    },
    numberWithSpaces(value) {
      // x=Math.round(x*100)/100;
      // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      let fixedNumber = parseFloat(value)
      fixedNumber = fixedNumber ? fixedNumber : 0
      fixedNumber = fixedNumber.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2})
      return fixedNumber
    },
    createSeries(value, name, color) {

      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = value
      series.dataFields.categoryX = 'date'
      series.name = name
      series.fill = am4core.color(color)

      var columnTemplate = series.columns.template;
      columnTemplate.column.cornerRadiusTopLeft = 100;
      columnTemplate.column.cornerRadiusTopRight = 100;
      columnTemplate.strokeOpacity = 0;

      return series;
    },
    createNewChart() {
      this.chart = null;
      if(this.idChartDirChange !== null && this.idChartDirChange !== undefined) {
        this.idChartDir = this.idChartDirChange;
      }
      if(this.hideDate !== null && this.hideDate !== undefined) {
        this.hideDatePicker = this.hideDate;
      }
      this.chart = am4core.create(this.idChartDir, am4charts.XYChart);
      let chart = this.chart;
      this.chart.colors.step = 2;
      am4core.options.autoSetClassName = true;
      let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
      xAxis.dataFields.category = 'date'
      xAxis.renderer.cellStartLocation = 0.4
      xAxis.renderer.cellEndLocation = 0.6
      xAxis.renderer.grid.template.location = 0;
      xAxis.renderer.minGridDistance = 100;
      xAxis.renderer.grid.template.location = 0.5;
      let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      yAxis.min = 0;
      this.chart.data = this.dataChart;
      chart.cursor = new am4charts.XYCursor();
      chart.plotContainer.tooltipPosition = "pointer"
      chart.plotContainer.tooltipText = ".";
      chart.plotContainer.tooltip["getFillFromObject"] = false;
      chart.plotContainer.tooltip.background.fill = am4core.color("rgba(255,255,255,1)");
      chart.plotContainer.tooltip.background.fillOpacity = 1;
      chart.plotContainer.tooltip.label.fontSize = 13;
      let vm = this;
      chart.cursor.events.on("cursorpositionchanged", function(ev) {
        // let xAxis = ev.target.chart.xAxes.getIndex(0);
        // console.log(ev.target);
        // console.log(ev.target.xPosition);
        // console.log(ev.target._availableWidth);
        // console.log(ev.target._availableWidth * ev.target.xPosition);
        // var YDateHover = xAxis.positionElement(xAxis.toAxisPosition(ev.target.xPosition));


        let fullWidth = ev.target._availableWidth;
        let percent = ev.target.xPosition;
        let width = fullWidth * percent;
        let widthPartIndex = fullWidth / chart.data.length - 1;
        let widthIndex = 0;
        let firstIndex = 0;
        let secondIndex = 0;
        let choosed = false;
        for(let i=0; i<chart.data.length; i++) {
          if(width < widthIndex) {
            firstIndex = i-1;
            secondIndex = i;
            i = chart.data.length;
            choosed = true;
          }
          widthIndex +=widthPartIndex;
        }
        let widthForTest = secondIndex * widthPartIndex + widthPartIndex/2;
        let index = 0;

        if(!choosed) {
          if(index === 0) {
            let i = chart.data.length - 1;
            widthIndex = widthIndex * i;
            if(width < widthIndex) {
              firstIndex = i-1;
              secondIndex = i;
            }
          }
        }

        if(width < widthForTest) {
          index = firstIndex;
        } else {
          index = secondIndex;
        }



        // console.log(index)
        let text = "[#9AA3B0]" + ""+(vm.type === 'day' || vm.type === 'week' ? moment(vm.dataChart[index].dateNatural).format('MMMM D, YYYY') : vm.type === 'month' ? moment(vm.dataChart[index].dateNatural).format('MMMM, YYYY') : vm.type === 'year' ? moment(vm.dataChart[index].dateNatural).format('YYYY') : '') + "[/]\n";
        text += "[#0FA54E]●[/] " + "[#4B4B4B] $: " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(vm.dataChart[index].income) + "[/]" + "\n";
        text += "[#E85353]●[/] " + "[#4B4B4B] $: " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(vm.dataChart[index].expense) + "[/]" + "\n";

        chart.plotContainer.tooltipText = text;

        //
        // let item = vm.arraySeries[0].dataItems.getIndex(index);
        // let text = "[#9AA3B0]" + item.dateX.getDate() + ", " + item.dateX.toLocaleString('eng', { month: 'long' }) + "[/]\n";
        // for(let i=0; i<vm.arraySeries.length; i++) {
        //   item = vm.arraySeries[i].dataItems.getIndex(index);
        //   let value = item.valueY;
        //   if(value === undefined) {
        //     value = "\t—"
        //   }
        //   text += "[" + vm.arraySeries[i].stroke.hex + "]●[/] " + "[#9AA3B0]" + vm.arraySeries[i].name + ": " + "[/]" + "[#4B4B4B]" + vm.numberWithSpaces(value) + "[/]" + "\n";
        // }
        // chart.plotContainer.tooltipText = text;
      });
    }
  },
  mounted() {
    if(localStorage.getItem(this.$route.path+"2") !== null && localStorage.getItem(this.$route.path+"2") !== undefined) {
      let date = JSON.parse(localStorage.getItem(this.$route.path+"2"));
      if((""+date[0]) !== "null") {
        date[0] = (new Date(moment(date[0]).format("YYYY,MM,DD")));
      }
      if((""+date[1]) !== "null") {
        date[1] = (new Date(moment(date[1]).format("YYYY,MM,DD")));
      }
      this.activeDate = date
    }
    this.createNewChart()
  }
}
</script>

<style scoped lang="scss">
  @import "payment-list-charts";
</style>